import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { UserService } from "../../../components/mesc/mesc.service";
import { Router } from '@angular/router';

@Injectable()
export class ConfigurationService extends BehaviorSubject<any> {
    constructor(
        private router: Router,
        private userService: UserService
    ) {
        super(null);
    }
    private userSettings: UserSettings = new UserSettings(this.userService);

    /**
     * Return userSettings
     */
    getUserSettings = (): UserSettings => this.userSettings;


    /**
     * 
     */
    handleChange = (dataItem: any): void => {
        const _columns: any[] = this.value;
        const obj = _columns.find(x => x.field === dataItem.column.field);
        if (obj) {
            obj.width = dataItem.column.width;
        }
        this.saveUserSettings();
    }

    /**
     * 
     */
    saveUserSettings = (gridState = null): Promise<any> => {
        const _settings = {
            columns: this.value
                .map(column => ({
                    field: column.field,
                    visible: column.visible,
                    filterable: column.filterable,
                    sortable: column.sortable,
                    width: column.width,
                }))
        }
        if (gridState) {
            _settings['gridState'] = gridState;
        }
        return this.userSettings.saveSetting(this.router.url, _settings)
    };


    /**
     * Reorder the column dtos
     * Find the local indices of the newIndex and oldIndex then splice the array
     * @param e 
     */
    reorderColumns(e) {
        const columns: any[] = this.value;
        const visibleColumns: any[] = this.value.filter(c => c.visible);
        if (e.newIndex >= visibleColumns.length) return;
        const field = visibleColumns[e.newIndex].field;
        const oldIndex = columns.indexOf(columns.find(c => c.field === e.column.field));
        const newIndex = columns.indexOf(columns.find(c => c.field === field));
        const temp = columns[oldIndex];
        columns.splice(oldIndex, 1);
        columns.splice(newIndex, 0, temp);
        this.next(columns);
        this.saveUserSettings();
    }

}


/**
 * 
 */
class UserSettings extends BehaviorSubject<any> {
    loading: BehaviorSubject<boolean> = this.service.loading;
    constructor(private service: UserService) {
        super(null);
        this.service.read('/GetUserSettings')
            .then(u => u ? this.next(u.Settings ? JSON.parse(u.Settings) : {}) : null);
    }
    /**
     * 
     */
    saveSetting = (_path: string, _value: any): Promise<any> => {
        const _settings = this.value;
        _settings[_path] = _value;
        this.next(_settings);

        const obj: any = { Settings: JSON.stringify(this.value) };
        return this.service.save(obj, true, '/SaveUserSettings');
    };

}
